export default "__VITE_ASSET__IGuTja3J__"